package one.devsbox.www.ui.home

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.io.Repository
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class HomeVM : NavigationViewModel() {


    var menuItems by mutableStateOf<List<Node>>(emptyList())
        private set
    private lateinit var ctx: HomeCtx

    var active by mutableStateOf(Node.EmptyUI)
        private set

    var state by mutableStateOf<DataState<Unit>>(DataState.Loading())
        private set

    interface Action {
        fun navTo(node: Node)
    }

    val action = object : Action {
        override fun navTo(node: Node) {
            ctx.nav.findChildNavigation(Graph.HomeContent)?.also {
                it.navigateTo(node = node, clearTop = true)
            }
            active = node
        }
    }

    fun setup(ctx: HomeCtx) {
        this.ctx = ctx
        load()
    }

    fun load() {
        state = DataState.Loading()
        val permission = ctx.me.permission
        menuItems = buildList {
            if (permission.campaign.read) add(Node.ListingCampaignsUI)
            if (permission.application.read) add(Node.ListingAppsUI)
            if (permission.media.read) add(Node.ListingResourcesUI)
            if (permission.location.read) add(Node.ListingLocationUI)
            if (permission.device.read) add(Node.ListingDevicesUI)
            if (permission.user.read) add(Node.ListingUsersUI)
            if (permission.company.read && ctx.me.info.adminMode) add(Node.ListingCompanyUI)
        }
        state = if (menuItems.isEmpty()) {
            DataState.Error("NOT UI PERMISSIONS")
        } else {
            DataState.Result(Unit)
        }
    }

    override fun onRelease() {}
}
